import { render, staticRenderFns } from "./chargeable_term.vue?vue&type=template&id=39868c1a&"
import script from "./chargeable_term.vue?vue&type=script&lang=js&"
export * from "./chargeable_term.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports